<app-header></app-header>
<app-right-side></app-right-side>
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="assets/img/loader.webp">
</div>
<div class="container">
    <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div style="background-color: #fff;" class="ui-block">
                <div class="top-header top-header-favorit">
                    <div class="top-header-thumb">
                        <img src="assets/img/covers/{{countryData.continent_id}}.webp" alt="cover" class="img-responsive img-fluid" onerror="this.onerror=null;this.src='assets/img/club-cover.webp';" style="width: 100%;height: 100%;">
                        <div class="row">
                            <div class="col col-xl-9 col-lg-9 col-md-7 col-sm-8 col-7">
                                <div class="top-header-author">
                                    <div class="author-thumb">
                                        <img src="assets/svg-icons/1x1/{{countryData.code | lowercase}}.svg" alt="flag" class="img-responsive img-fluid" style="width: 100%; height: 100%;" onerror="this.onerror=null;this.src='assets/img/clubs.webp';">
                                    </div>
                                    <div class="author-content">
                                        <p class="h3 author-name">{{countryData.name}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-xl-3 col-lg-2 col-md-3 col-sm-3 col-3">
                                <div class="top-header-author">
                                    <div class="author-thumb ph" style="float: left!important;">
                                        <img src="https://www.api.football-family.com/federations/{{countryData.code}}.png" class="img-responsive float-left" alt="flag" onerror="this.onerror=null;this.src='assets/img/clubs.webp';" style="width: 100%; height: 100%;">
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="profile-section" *ngFor="let Icount of fanscount">
                        <div class="row">
                            <div class="col col-xl-8 m-auto col-lg-8 col-md-12">
                                <ul class="profile-menu">
                                    <li>
                                        <a routerLinkActive="active"  >Fans ({{ Icount.fanscount }})</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div *ngFor="let Icount2 of fanscount" class="ui-block-title">
                <h6 *ngIf="Icount2.fanscount === 0" class="display-message">No Data Found!
                </h6>
            </div>
        </div>
    </div>
</div>
<div></div>
<br>
<div class="container">
    <div class="row">
        <div *ngFor="let Item2 of fansname" class="col col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="ui-block" data-mh="friend-groups-item" style="background-color: rgb(236, 236, 236);">
                <div class="friend-item friend-groups">
                    <span style="padding-left: 5px; margin-top: 5px; position: absolute;"><i class="fa fa-user" style="color: #ffffff; font-size: 25px;"></i></span>
                    <div class="friend-item-content">
                        
                        <div class="friend-avatar">
                            <div class="author-thumb">
                                <a routerLink="/friend-about" [queryParams]="{'id': Item2.id,'role': 'Fan'}">
                                    <img *ngIf="!Item2.avatar" src="assets/img/author-main1.webp" alt="author" style="width: 100%;">
                                    <img *ngIf="Item2.avatar" [src]="Item2.avatar" alt="author" onerror="this.onerror=null; this.src='assets/img/author-main1.webp';" class="img-responsive img-fluid" style="width: 100%; height: auto;">
                                </a>
                            </div>
                            <div class="author-content">
                                <a routerLink="/friend-about" [queryParams]="{'id': Item2.id,'role': 'Fan'}" class="author-name" style="color: #000000; font-size: 15px;">
                                    {{Item2.fullName}} {{Item2.lastName}}
                                    <br>
                                    ({{Item2.role}})
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center">
            <div>
                <jw-pagination [items]="items" (changePage)="onChangePage($event)"></jw-pagination>
            </div>
        </ul>
    </nav>
</div>